import { createElement } from 'react';
import { Navigate } from 'react-router-dom';

import { polymarketRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const polymarketRoute: RouteObject[] = [
  {
    path: polymarketRoutePaths.list.path,
    async lazy() {
      const Page = await import('@/pages/polymarket/PolymarketListPage');
      return { Component: Page.default };
    },
  },
  {
    path: polymarketRoutePaths.detail.path,
    async lazy() {
      const Page = await import('@/pages/polymarket/PolymarketDetailPage');
      return { Component: Page.default };
    },
  },
  {
    // 비로그인도 열람 가능 — 공개 라우트 (spec §1-3, TRAD-1607)
    path: polymarketRoutePaths.leaderboard.path,
    async lazy() {
      const Page = await import('@/pages/polymarket/LeaderboardPage');
      return { Component: Page.default };
    },
  },
  {
    // 하위호환: /polymarket/me → /polymarket/my 리다이렉트 (공개 라우트로 이동 — TRAD-1618 TC67)
    path: polymarketRoutePaths.me.path,
    element: createElement(Navigate, { to: polymarketRoutePaths.my.fullPath, replace: true }),
  },
  {
    // 비로그인 시 인라인 CTA 표시 (하드 redirect 제거 — TRAD-1618 TC67)
    path: polymarketRoutePaths.my.path,
    async lazy() {
      const Page = await import('@/pages/polymarket/MyPolymarketPage');
      return { Component: Page.default };
    },
  },
];

export const polymarketPrivateRoute: RouteObject[] = [
  {
    path: polymarketRoutePaths.propose.path,
    async lazy() {
      const Page = await import('@/pages/polymarket/ProposalFormPage');
      return { Component: Page.default };
    },
  },
];
